/** Empty transform object with no transformation properties */
const meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  flipX: false,
  flipY: false,
  rotate: 0
};

export { meaninglessTransform as m };
//# sourceMappingURL=meaninglessTransform-DIm6EBap.js.map
